import React, { useId } from 'react';
import { Switch } from '@headlessui/react';
import { routeDetailsClasses } from '../../common/tailwindClassnames';
import SwitchVisual, { switchTrackFill } from '../SwitchVisual';

interface CustomCheckboxProps {
  schema?: any;
  value?: any;
  label: string;
  checked?: boolean;
  itemsData?: any;
  enumItem?: any;
  onChange: (updatedItems: boolean | any[]) => void;
  formData: any;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  schema,
  value,
  label,
  checked,
  itemsData,
  enumItem,
  onChange,
  formData,
}) => {
  // enumItem defined means we're rendering one item of an array-enum field.
  // formData may be undefined on the first render before CustomArrayField initialises it,
  // so fall back to itemsData (the already-selected items array) for the checked state.
  const isArrayItem = enumItem !== undefined && enumItem !== null;
  const selectedItems: any[] = Array.isArray(formData)
    ? formData
    : Array.isArray(itemsData)
      ? itemsData
      : [];
  const isChecked = isArrayItem
    ? selectedItems.includes(enumItem)
    : (formData ?? value ?? checked ?? false);

  const handleChange = (checked: boolean) => {
    onChange(checked);
  };

  const fieldLabel = schema?.title || label;
  // Stable, HTML-valid id for aria-labelledby — labels (e.g. oneOf titles)
  // can contain spaces/punctuation and are not guaranteed unique.
  const labelId = useId();
  const switchEl = (
    <Switch
      checked={isChecked}
      onChange={handleChange}
      className={` ${routeDetailsClasses?.switchContainer || ''} ${switchTrackFill(isChecked)} `}
      aria-label={isArrayItem ? undefined : fieldLabel}
      aria-labelledby={isArrayItem ? labelId : undefined}
    >
      <span className="sr-only">{isChecked ? 'Enabled' : 'Disabled'}</span>
      <SwitchVisual on={isChecked} />
    </Switch>
  );

  return isArrayItem ? (
    <div className="flex w-full items-center justify-between">
      <span id={labelId} className="text-ui-text-primary-text">
        {fieldLabel}
      </span>
      {switchEl}
    </div>
  ) : (
    switchEl
  );
};

export default CustomCheckbox;
